import PatientPopulationChart from './PatientPopulationChart'

export default PatientPopulationChart
